/** Script-Tag-ID für eingebettetes Menu-Bundle (liegt bewusst außerhalb #app). */
export const PRERENDER_MENU_BUNDLE_SCRIPT_ID = 'tastio-prerender-menu-bundle';
export const readPrerenderMenuBundleFromDocument = () => {
    if (typeof document === 'undefined')
        return null;
    const node = document.getElementById(PRERENDER_MENU_BUNDLE_SCRIPT_ID);
    if (!node?.textContent?.trim())
        return null;
    try {
        const parsed = JSON.parse(node.textContent);
        if (!Array.isArray(parsed.products) || parsed.products.length === 0)
            return null;
        return parsed;
    }
    catch {
        return null;
    }
};
/** Escaped JSON für sicheres Einbetten in HTML (verhindert </script>-Breakout). */
export const serializeMenuBundleForPrerender = (bundle) => JSON.stringify({
    products: bundle.products || [],
    categories: bundle.categories || [],
    ingredients: bundle.ingredients || [],
    ingredientCategories: bundle.ingredientCategories || [],
    menus: bundle.menus || []
}).replace(/</g, '\\u003c');
export const buildPrerenderMenuBundleScript = (bundle) => {
    const json = serializeMenuBundleForPrerender(bundle);
    return `<script type="application/json" id="${PRERENDER_MENU_BUNDLE_SCRIPT_ID}">${json}</script>`;
};
export const injectPrerenderMenuBundleIntoHtml = (html, bundle) => {
    if (!Array.isArray(bundle.products) || bundle.products.length === 0)
        return html;
    const script = buildPrerenderMenuBundleScript(bundle);
    if (html.includes('</body>')) {
        return html.replace('</body>', `${script}</body>`);
    }
    return `${html}${script}`;
};
